import { NgModule } from '@angular/core';
import { WebcamModule } from 'ngx-webcam';

const modules = [
  WebcamModule
]

@NgModule({
  declarations: [],
  imports: [
    modules
  ], 
  exports: [
    modules
  ]
})
export class CameraModule { }
